import hunt from 'huntjs';

class DeferIframe {
    constructor(el) {

        // store for later
        this.el = el;
        this.dataSrc = this.el.dataset.src;
        let _this = this;

        let huntConfig = {
            enter: (el) => {
                el.setAttribute('src', _this.dataSrc);
                if(el.complete) {
                    _this.el.classList.add('loaded');
                } else {
                    el.onload = () => {
                        _this.el.classList.add('loaded');
                    };
                }
            }
        };

        // create hunt
        new hunt(el, huntConfig);
    }
}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new DeferIframe(node);
        }
    });
}